import React, {useCallback, useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {View} from 'react-native';

import {setCurrentGroupId} from 'src/Redux/reducers/user_info.reducer';
import {parsePlayerChallegeData} from 'src/Utils/dataHelper';
import {navigationRef} from 'src/Nav/navigationHelpers';
import {
  setCurrentChallengeId,
  setCurrentLocationId,
  setLocationChallengeData,
} from '../Redux/reducers/game_v2.reducer';
import {
  updateAnytimePhotosData,
  updatePlayerChallengeData,
  updateTreasureChallengeData,
} from '../Redux/reducers/game.reducer';
import {setGroupInfo} from '../Redux/reducers/groupInfo.reducer';
import {dispatchAction} from '../Utils/helpers';
import {useFirebaseData} from '../Utils/fireUtils';
import {useLocationId} from '../Hooks/gameHooks';

const MainGameController = () => {
  const groupInfo = useSelector((state) => state.groupInfo) || {};

  const {
    huntFinished,
    huntPaused,
    huntStarted,
    groupPhoto,

    huntIntroDone,
    // huntPostCardFinished,
  } = groupInfo || {};
  const isClassicHunt = !!groupInfo?.classic_hunt;
  const previousScreen = useRef();

  const locationId = useLocationId();

  const userId = useSelector((state) => state.user?.userId);
  const userGroupId = useSelector(
    (state) => state.user?.info?.currentHuntInfo?.groupId,
  );

  console.log('MainHuntController tab rerender', {userGroupId});

  const currentScreen = useSelector(
    (state) => state.current_screen?.currentScreen,
  );

  const dispatch = useDispatch();

  const locationChallengeData =
    useFirebaseData(
      `scavengerhunt/completions/${userGroupId}/location_v2`,
      null,
      null, // no order by
      null, // no order by
      false, // show logs
      !userGroupId, // hide if no group id
    ) || {};

  useEffect(() => {
    console.log('location challenge data update', {
      locationChallengeDataKeys: Object.keys(locationChallengeData || {}),
    });
    locationChallengeData &&
      dispatchAction(setLocationChallengeData(locationChallengeData));
  }, [locationChallengeData]);

  useFirebaseData(
    `scavengerhunt/completions/${userGroupId}/treasure`,
    (treasureChallengesData) => {
      console.log('ltreasureChallengesData update');
      dispatch(updateTreasureChallengeData(treasureChallengesData));
    },
    null, // no order by
    null, // no order by
    false, // show logs
    !userGroupId, // hide if no group id
  );

  useFirebaseData(
    `scavengerhunt/completions/${userGroupId}/anytimePhotos`,
    async (anytimePhotosData = {}) => {
      console.log('updateAnytimePhotosData update');
      dispatch(updateAnytimePhotosData(Object.values(anytimePhotosData)));
    },
    null, // no order by
    null, // no order by
    false, // show logs
    !userGroupId, // hide if no group id
  );

  const firebaseGroupInfo = useFirebaseData(
    `scavengerhunt/groups/${userGroupId}`,
    async (groupData = {}) => {
      console.log('setting groups update');
      dispatch(setGroupInfo(groupData));
      dispatch(setCurrentGroupId(groupData?.groupId));
    },
    null, // no order by
    null, // no order by
    false, // show logs
    !userGroupId, // hide if no group id
  );

  useEffect(() => {
    console.log('firebaseGroupInfo changed');
  }, [JSON.stringify(firebaseGroupInfo)]);

  useFirebaseData(
    `scavengerhunt/completions/${userGroupId}/player`,
    async (playerChallengesData = {}) => {
      console.log('playerChallengesData update');
      const parsedData = parsePlayerChallegeData(playerChallengesData);
      dispatch(updatePlayerChallengeData(parsedData));
    },
    'parentUserId', // order by parent user id
    userId, // equal to my user id
    false, // show logs
    !userGroupId, // hide if no group id
  );

  const isCurrentScreenHuntPaused = useSelector(
    (state) => state.current_screen?.currentScreen == 'HuntPaused',
  );
  const isCurrentScreenHuntLoading = useSelector(
    (state) => state.current_screen?.currentScreen == 'HuntLoading',
  );

  const isCurrentScreenHuntFinished = useSelector(
    (state) => state.current_screen?.currentScreen == 'HuntFinished',
  );
  const isCurrentScreenGameLobby = useSelector(
    (state) => state.current_screen?.currentScreen == 'ScavengerHuntGameLobby',
  );

  const isClassicScreen = useSelector(
    (state) => state.current_screen?.currentScreen == 'ClassicChallenges',
  );

  const isCurrentScreenCharacterSelection = useSelector(
    (state) =>
      state.current_screen?.currentScreen == 'ScavengerHuntCharacterSelection',
  );

  const isCurrentScreenHuntIntro = useSelector(
    (state) => state.current_screen?.currentScreen == 'HuntIntro',
  );

  const isCurrentScreenTeamPhoto = useSelector(
    (state) => state.current_screen?.currentScreen == 'TeamPhoto',
  );

  const isModal = useSelector((state) => {
    const currentScreen = state.current_screen?.currentScreen;
    const isModal =
      [
        'CESModal',
        'ConfirmModal',
        'FAQ',
        'FoxShop',
        'PhotoVideoCamera',
        'HuntPostCardAddressConfirm',
        'PlayerDashboard_v2',
        'PlayerTreasureChallenges',
        'PlayerTrivia',
        'EventDashboardWrapper',
        'QuestionFeedback',
        'HuntSocialBonuses',
        'HuntPhotos',
        'ChallengeResultModal',
        'EventDashboard',
      ]?.includes?.(currentScreen) || currentScreen.includes('Modal');
    console.log('checking if modal', {isModal, currentScreen});
    return isModal;
  });

  const correctLocationId = useSelector((state) => {
    const {locations, locationList} = state?.game_v2;
    if (!locations || !locationList) {
      return null;
    }
    const unFinishedLocationIds = locationList.filter((key) => {
      var location = locations[key];

      // fixing for barhunt location closed

      // if (location?.startTime) {
      //   hasStartedLocationChallenges = true;
      // }
      return !location?.locationChallengesCompleteTime;
    });
    console.log({unFinishedLocationIds});
    return unFinishedLocationIds?.[0] || 'LocationsFinished';
  });

  const correctLocation = useSelector((state) => {
    return state?.game_v2?.locations?.[correctLocationId];
  });

  const correctChallenge = useSelector((state) => {
    const allChallenges = state?.game_v2?.allChallenges;
    if (!correctLocation || !allChallenges) {
      return null;
    }
    const challengeList = correctLocation?.challengeList;
    // console.log({challenges});

    // the navigation challenge was complete, so now finding the index of the highest non-competed challenge
    const highestNonCompletedChallengeId = challengeList?.filter((key) => {
      return (
        !allChallenges[key]?.scoreReviewTime &&
        !allChallenges[key]?.completeTime
      );
    })?.[0];

    console.log({highestNonCompletedChallengeId, challengeList});

    const newCorrectChallenge = allChallenges[highestNonCompletedChallengeId];

    if (!newCorrectChallenge) {
      return 'LocationFinished';
    }

    return newCorrectChallenge;
  });

  console.log({correctLocationId, correctChallenge});

  const isHuntLoading = useSelector((state) => {
    // no group info
    if (!state.groupInfo) {
      return true;
      // if hunt started also check for locations & questions
    } else if (state?.groupInfo?.huntStarted) {
      if (
        !state?.game_v2?.locationList?.[0] &&
        !state?.game_v2?.classicChallengeList?.[0]
      ) {
        return true;
      }
    }
    return false;
  });

  const devicePlayersHaveCharacters = useSelector((state) => {
    const players = state.groupInfo?.players;
    if (!players) {
      return 0;
    }
    const allPlayers = Object.values(players);
    const devicePlayersHaveCharacters =
      allPlayers &&
      allPlayers
        .filter((player) => userId == player.parentUserId)
        .every((player) => player.character);
    return devicePlayersHaveCharacters;
  });

  // key function
  // handling next
  const handleNext = useCallback(
    (force = false) => {
      console.log('handling redirect', {
        huntPaused,
        huntStarted,
        huntFinished,
        groupPhoto,
        groupInfo,
        huntIntroDone,
        devicePlayersHaveCharacters,
        isCurrentScreenTeamPhoto,
        correctLocationId,
        correctChallenge,
        isHuntLoading,
        // huntPostCardFinished,
      });

      // checking if all hunt data is loaded
      if (isHuntLoading) {
        return console.log('Hunt still loading', {groupInfo});
      }

      // simple function to see if on right page
      const checkIfRightPageOrNavigate = (condition, page) => {
        if (condition) {
          return console.log('checkingCurrentPageErrors on right page:', {
            condition,
            page,
          });
        } else {
          console.log('checkingCurrentPageErrors on right page navigating:', {
            condition,
            page,
          });
          return navigationRef.navigate(page);
        }
      };

      if (huntPaused) {
        return checkIfRightPageOrNavigate(
          isCurrentScreenHuntPaused,
          'HuntPaused',
        );
      }

      // checking if a modal is open
      if (isModal && !force) {
        return console.log('CESModal blocked redirect');
      }
      console.log('checkingCurrentPageErrors fired');

      // checking if hunt finished, if finished either hunt post card
      // or hunt finished
      if (huntFinished) {
        // show hunt post card
        // if (!huntPostCardFinished) {
        //   return checkIfRightPageOrNavigate(
        //     isCurrentScreenHuntPostCard,
        //     'HuntPostCard',
        //   );
        //   // show HuntFinished
        // } else {
        return checkIfRightPageOrNavigate(
          isCurrentScreenHuntFinished,
          'HuntFinished',
        );
        // }
      }

      // hunt is not started, so must be in game lobby
      if (!huntStarted) {
        return checkIfRightPageOrNavigate(
          isCurrentScreenGameLobby,
          'ScavengerHuntGameLobby',
        );
      }

      // checking if all players have info
      if (!devicePlayersHaveCharacters) {
        return checkIfRightPageOrNavigate(
          isCurrentScreenCharacterSelection,
          'ScavengerHuntCharacterSelection',
        );
      }

      // checking if hunt intro is done
      if (!huntIntroDone) {
        return checkIfRightPageOrNavigate(
          isCurrentScreenHuntIntro,
          'HuntIntro',
        );
      }

      // checking if group photo is taken
      if (!groupPhoto) {
        return checkIfRightPageOrNavigate(
          isCurrentScreenTeamPhoto,
          'TeamPhoto',
        );
      }

      // remaining logic depends if classic or not
      if (isClassicHunt) {
        checkIfRightPageOrNavigate(isClassicScreen, 'ClassicChallenges');
        return navigationRef.navigate('ClassicChallenges');

        //
      } else {
        // setting the location challenges
        if (correctLocationId != locationId || isCurrentScreenHuntLoading) {
          dispatch(
            setCurrentLocationId(
              correctLocationId == 'LocationsFinished'
                ? null
                : correctLocationId,
            ),
          );
        }

        console.log('------------------------------------');
        console.log('--Determining Right Location Page---');
        console.log('------------------------------------');

        console.log({correctLocation});

        // navigating to hunt outro confirmation page
        if (correctLocationId == 'LocationsFinished') {
          dispatch(setCurrentLocationId(null));
          dispatch(setCurrentChallengeId(null));
          return navigationRef.navigate('HuntOutro');

          // navigating to hunt outro confirmation page
        } else if (!correctLocation?.completeTime) {
          dispatch(setCurrentChallengeId(null));
          return navigationRef.navigate('NavigationChallenge');

          // navigating to hunt outro confirmation page
        } else if (correctChallenge == 'LocationFinished') {
          return navigationRef.navigate('LocationComplete');

          // navigating to hunt outro confirmation page
        } else if (correctChallenge) {
          // console.log('setting setCurrentChallengeId', {
          //   challengeId: correctChallenge?.challengeId,
          // });
          // dispatch(setCurrentChallengeId(correctChallenge?.challengeId));
          const newScreen = 'LocationChallenges';
          navigationRef.navigate(
            newScreen,
            `MainGameController.js was forced ${force}`,
          );
          console.log({previousScreen});

          previousScreen.current = newScreen;
          return;
          //
        }
      }

      return console.warn('Made to end!!');
    },
    [
      currentScreen,
      currentScreen,
      JSON.stringify(groupInfo),
      huntPaused,
      devicePlayersHaveCharacters,
      huntIntroDone,
      isCurrentScreenTeamPhoto,
      isModal,
      huntFinished,
      isCurrentScreenHuntLoading,
      JSON.stringify(correctChallenge),
      isCurrentScreenHuntFinished,
      correctLocationId,
      isHuntLoading,
      // huntPostCardFinished,
    ],
  );

  useEffect(() => {
    handleNext();
  }, [
    currentScreen,
    currentScreen,
    JSON.stringify(groupInfo),
    huntPaused,
    devicePlayersHaveCharacters,
    huntIntroDone,
    isCurrentScreenTeamPhoto,
    isModal,
    huntFinished,
    isCurrentScreenHuntLoading,
    JSON.stringify(correctChallenge),
    isCurrentScreenHuntFinished,
    correctLocationId,
    isHuntLoading,
    // huntPostCardFinished,
  ]);

  global.handleNext = handleNext;

  console.log('MainHuntController Decided to render', {groupInfo});

  return <View></View>;
};

export default MainGameController;
